import { render, staticRenderFns } from "./ZonasList.vue?vue&type=template&id=44764c04&"
import script from "./ZonasList.vue?vue&type=script&lang=js&"
export * from "./ZonasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports